import { EAppThemeMode } from '@aquariuxfintech/aqx-trader-sdk-config/types';
import { colorFormatter } from '@aquariuxfintech/aqx-trader-sdk-config/utils';

export const isValueRGB = (color: string) => {
  return color.match(
    /^rgb[(](?:\s*0*(?:\d\d?(?:\.\d+)?(?:\s*%)?|\.\d+\s*%|100(?:\.0*)?\s*%|(?:1\d\d|2[0-4]\d|25[0-5])(?:\.\d+)?)\s*(?:,(?![)])|(?=[)]))){3}[)]$/
  );
};

export const rgbToHex = (rgbValue: string) => {
  const rgbBlocks = rgbValue.match(/\d+/g);

  if (!rgbBlocks || rgbBlocks.length !== 3) {
    throw new Error('Invalid RGB string format');
  }

  const hexComponents = rgbBlocks.map((component) => {
    const hex = Number(component).toString(16);

    return hex.length === 1 ? '0' + hex : hex;
  });

  return '#' + hexComponents.join('');
};

export const convertColorValue = (color: string, format: 'rgb' | 'hex') => {
  switch (format) {
    case 'hex': {
      const isRGB = isValueRGB(color);

      if (isRGB) {
        return rgbToHex(color);
      }
      break;
    }
    default:
      break;
  }

  return color;
};

export const getLightBackgroundColor = (color: string, themeMode: EAppThemeMode = EAppThemeMode.LIGHT) => {
  const colorInstance = colorFormatter(color);
  return themeMode === EAppThemeMode.DARK
    ? colorInstance.darken(0.7).rgb().string()
    : colorInstance.lighten(0.9).rgb().string();
};

export const getHoverBackgroundColor = (color: string, themeMode: EAppThemeMode = EAppThemeMode.LIGHT) => {
  const colorInstance = colorFormatter(color);
  return themeMode === EAppThemeMode.DARK
    ? colorInstance.darken(0.5).rgb().string()
    : colorInstance.lighten(0.7).rgb().string();
};
